import * as Sentry from '@sentry/browser';
import * as angular from 'angular';
import * as printStackTrace from 'stacktrace-js';

(function () {
    'use strict';

    angular
        .module('app')
        .factory('exceptionLoggingService', exceptionLoggingService);

    /**
     * Service to handle exceptions and logging.
     * Takes advantage of the overridden exceptionHandler to log exceptions to the server that would normally
     * end up in the clients JavaScript console where we they're last as we can't see them.
     * This should not be injected anywhere except for the exceptionHandler, because it fires automatically
     * upon exceptions. If you want to log manually, use applicationLoggingService.
     *
     * @see http://engineering.talis.com/articles/client-side-error-logging/
     * @ngInject
     */
    function exceptionLoggingService($log) {
        function error(exception) {
            // Preserve the default behavior of Angular's exception handling:
            // Log to client's JavaScript console and keep the app running.
            $log.error.apply($log, arguments);

            // Now try to log the error to sentry.
            try {
                Sentry.captureException(exception);
            } catch (loggingError) {
                $log.warn('Error server-side logging failed');
                $log.log(loggingError);
            }
        }

        return error;
    }
})();
